
import { Component, Prop, Vue } from 'vue-property-decorator'
import DashboardButton from '@/components/common/buttons/DashboardButton.vue'
import FooterBasic from '~/components/common/modals/basic/FooterBasic.vue'
import ModalBasic from '~/components/common/modals/common/ModalBasic.vue'
import Icon from '~/components/common/icon/Icon.vue'
import { manageWidgets } from '~/lib/utils/utils'

@Component({
  components: {
    ModalBasic,
    DashboardButton,
    FooterBasic,
    Icon
  }
})
export default class AutoApplicationModal extends Vue {
  @Prop({ type: Function, default: () => {} }) readonly yesHandler: boolean
  @Prop({ type: Function, default: () => {} }) readonly noHandler: boolean

  mounted() {
    manageWidgets(true)
  }

  beforeDestroy() {
    manageWidgets(false)
  }

  get scholarshipImageSrc() {
    return this.$vp.l || this.$vp.xl || this.$vp.xxl
      ? require('~/assets/images/scholarship-example-desktop.png')
      : require('~/assets/images/scholarship-example-mobile.png')
  }
}
